import {setupKey} from '../../utils/eventSetup';
import {pendingResourceNoteIds} from '../../utils/resourceReview';
import {isReviewableVideo} from '../../utils/overviewVodValidity';

// Match notes take precedence over their migrated video-level copies, just as
// they do in the unread count. A reply jump targets its parent note's moment.
export function reviewTaskTarget(row,slot,threads,uid,username){
 const canonical=new Set(threads.filter(thread=>thread.key.includes('/matches/')).flatMap(thread=>thread.notes.map(note=>note.id)));
 const candidates=threads.flatMap(thread=>{
  const notes=thread.key.includes('/videos/')?thread.notes.filter(note=>!canonical.has(note.id)):thread.notes;
  const pending=new Set(pendingResourceNoteIds(notes,thread.replies,uid,username));
  return notes.filter(note=>pending.has(note.id)).map(note=>({note,key:thread.key}));
 }).sort((a,b)=>noteTime(a.note)-noteTime(b.note)||String(a.note.id).localeCompare(String(b.note.id)));
 const first=candidates[0],videos=slot.videos.filter(isReviewableVideo);
 const legacyId=first?.key.includes('/videos/')?first.key.split('/').pop():null;
 const video=videos.find(video=>video.id===(legacyId||first?.note.videoId))||videos[0];
 if(!video)return {to:'/library'};
 const target=first?{videoId:video.id,noteId:first.note.id,timeSec:noteTime(first.note),noteMode:first.key.includes('/matches/')?'match':'video',timeMode:first.key.includes('/matches/')||Number.isFinite(first.note.matchTimeSec)?'match':'video'}:null;
 if(row.event?.eventId){
  const params=new URLSearchParams({calendarTeam:row.teamId,eventWorkspace:setupKey(row.event,slot.id),eventTab:'vod',eventVideo:video.id});
  if(target){params.set('eventNote',target.noteId);params.set('eventTime',String(target.timeSec));params.set('eventTimeMode',target.timeMode);params.set('eventNoteMode',target.noteMode);}
  return {to:'/home?'+params,workspaceTarget:{event:row.event,slotId:slot.id,videoId:video.id,reviewTarget:target}};
 }
 const params=new URLSearchParams({teamId:row.teamId});
 return {to:'/review/'+encodeURIComponent(slot.mapId)+'/'+encodeURIComponent(video.id)+'?'+params};
}
function noteTime(note){const value=note.matchTimeSec??note.timestamp;return typeof value==='number'&&Number.isFinite(value)?Math.max(0,value):0;}

export function readReviewTarget(params){
 const noteId=params.get('eventNote'),raw=params.get('eventTime'),timeSec=Number(raw),videoId=params.get('eventVideo');
 if(!noteId||noteId.length>256||!videoId||raw===null||!Number.isFinite(timeSec)||timeSec<0||timeSec>7*86400)return null;
 return {videoId,noteId,timeSec,noteMode:params.get('eventNoteMode')==='video'?'video':'match',timeMode:params.get('eventTimeMode')==='video'?'video':'match'};
}
